// extracted by mini-css-extract-plugin
export default {"container":"Validate_container__Op6-J","box":"Validate_box__MFkyy"};